import './normalize.css';
import './typography.less';
import './markup.less';
import './wysiwyg.less';
import './layout.less';
import Header from '../header/index';
import Footer from '../footer/index';
import '../analytics/index';

// trim-below
import React from 'react';
import PropTypes from 'prop-types';
import Guides from '../guides/index';

export default function Layout({children}) {
	return (
		<div className="layout">
			<Header/>
			{children}
			<Footer/>
		</div>
	);
}

Layout.propTypes = {
	children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/layout/index.jsx